var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterthan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    focusable: "false",
    "aria-hidden": "true",
    stroke: "#545b64",
    strokeWidth: 2,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 1 7 7-7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterthan);
export default __webpack_public_path__ + "static/media/greaterthan.c62914ee50bf9abbc5db203d928bdc4e.svg";
export { ForwardRef as ReactComponent };